module.exports = __webpack_public_path__ + "static/media/token-preview-peach.a28e5f9d.png";